import { Box } from '@apia/theme';
import { observer } from 'mobx-react-lite';
import { IAttachment } from '../ChatController';
import { ReactNode } from 'react';
import Attachments from './Attachments';
import { TMessageType } from '../types';

export const Message = observer(
  ({
    className,
    type,
    id,
    message,
    attachments,
    reference,
  }: {
    className?: string;
    type: TMessageType;
    id: string;
    message: ReactNode;
    attachments: IAttachment[];
    reference: ReactNode;
  }) => {
    return (
      <Box
        as="pre"
        className={`history_message ${className || ''} ${type}`}
        key={id}
      >
        <Box
          className="history_message__content"
          {...(typeof message === 'string'
            ? { dangerouslySetInnerHTML: { __html: message } }
            : { children: message })}
        />
        {attachments.length > 0 && (
          <Attachments attachments={attachments}></Attachments>
        )}
        {reference && (
          <Box className="history_message__references">{reference}</Box>
        )}
      </Box>
    );
  },
);
